export default __webpack_public_path__ + "static/media/webm.00c1d062.svg";